import Input from '@/shared/components/UI/Input';
import Button from '@/shared/components/UI/Button';
import LinkButton from '@/shared/components/UI/LinkButton';

import { useFindPassword } from '../hooks/useFindPassword';

const FindPassword = () => {
  const { email, setEmail, handleSubmit } = useFindPassword();

  return (
    <section className="min-h-[20rem] text-center">
      <h3 className="text-[24px] font-extrabold text-[#95699f]">
        FIND PASSWORD
      </h3>
      <p className="mt-3 text-sm font-medium text-[#444]">
        We will send a new password to your registered email address
      </p>
      <form
        method="post"
        onSubmit={handleSubmit}
        className="mx-auto mt-8 flex w-[30rem] flex-col items-center justify-center"
        id="login-form"
      >
        <Input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          fullWidth={false}
          className="mb-3 w-[30rem] text-sm placeholder:text-sm"
        />
        <Button
          type="submit"
          variant="secondary"
          size="md"
          className="mt-10 w-40"
        >
          SEND
        </Button>
        <LinkButton
          to="/login"
          variant="underline"
          className="mt-3 text-xs font-semibold"
        >
          Back to Login
        </LinkButton>
      </form>
    </section>
  );
};

export default FindPassword;
